/**
 * 出租率：一次拉取过去 7 天 / 30 天 / 12 个月三组图表
 */
import { useState, useCallback, useEffect } from 'react';
import { getOccupancyAnalysisFromProxy, } from '../../service/storeRevenueApi';
export function pickOccupancyChart(bundle, range) {
    var _a, _b, _c;
    if (!bundle)
        return undefined;
    if (range === '7d')
        return (_a = bundle.last7Days) === null || _a === void 0 ? void 0 : _a.chartData;
    if (range === '30d')
        return (_b = bundle.last30Days) === null || _b === void 0 ? void 0 : _b.chartData;
    return (_c = bundle.last12Months) === null || _c === void 0 ? void 0 : _c.chartData;
}
var emptyAxes = {
    left: { id: 'left', position: 'left', name: '出租率', unit: '%', min: 0, max: 150 },
    right: { id: 'right', position: 'right', name: '间夜数', unit: '间', min: 0, max: 100 },
};
var emptyBlock = {
    chartData: {
        categories: [],
        dataset: { occupancyRate: [], roomOvernightRate: [], hourScale: [], roomNight: [] },
        axes: emptyAxes,
        series: [],
    },
};
var emptyBundle = {
    last7Days: emptyBlock,
    last30Days: emptyBlock,
    last12Months: emptyBlock,
};
export function useOccupancyAnalysisData(storeId, options) {
    var enabled = (options === null || options === void 0 ? void 0 : options.enabled) !== false;
    var _a = useState(emptyBundle), data = _a[0], setData = _a[1];
    var _b = useState(function () { return enabled; }), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(0), refreshKey = _d[0], setRefreshKey = _d[1];
    var refresh = useCallback(function () { return setRefreshKey(function (k) { return k + 1; }); }, []);
    useEffect(function () {
        if (!enabled) {
            setLoading(false);
            setError(null);
            setData(emptyBundle);
            return;
        }
        var cancelled = false;
        setLoading(true);
        setError(null);
        getOccupancyAnalysisFromProxy(storeId)
            .then(function (res) {
            if (cancelled)
                return;
            setData(res !== null && res !== void 0 ? res : emptyBundle);
        })
            .catch(function (err) {
            if (!cancelled) {
                setError(err instanceof Error ? err : new Error(String(err)));
                setData(emptyBundle);
            }
        })
            .finally(function () {
            if (!cancelled)
                setLoading(false);
        });
        return function () {
            cancelled = true;
        };
    }, [storeId, enabled, refreshKey]);
    return { data: data, loading: loading, error: error, refresh: refresh };
}
